import React from 'react';
interface ItineraryDay {
  day: number;
  title: string;
  description: string;
  activities: string[];
}
interface QuotationItineraryProps {
  days: ItineraryDay[];
}
export function QuotationItinerary({
  days
}: QuotationItineraryProps) {
  return <div className="mb-6" data-id="element-960">
      <h3 className="text-sm font-bold text-neutral-900 uppercase tracking-wide mb-4 pb-2 border-b-2 border-neutral-300" data-id="element-961">
        Day-by-Day Itinerary
      </h3>

      <div className="space-y-5" data-id="element-962">
        {days.map(day => <div key={day.day} className="bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-963">
            {/* Day Header */}
            <h4 className="text-sm font-bold text-neutral-900 mb-2" data-id="element-964">
              Day {day.day} — {day.title}
            </h4>

            {/* Description */}
            <p className="text-xs text-neutral-700 leading-relaxed mb-3" data-id="element-965">
              {day.description}
            </p>

            {/* Activities */}
            {day.activities.length > 0 && <div data-id="element-966">
                <p className="text-xs font-semibold text-neutral-700 mb-1.5" data-id="element-967">
                  Activities:
                </p>
                <ul className="space-y-1" data-id="element-968">
                  {day.activities.map((activity, index) => <li key={index} className="text-xs text-neutral-600 flex items-start" data-id="element-969">
                      <span className="mr-2 text-blue-600" data-id="element-970">•</span>
                      <span data-id="element-971">{activity}</span>
                    </li>)}
                </ul>
              </div>}
          </div>)}
      </div>
    </div>;
}